import * as i0 from '@angular/core';
import { InjectionToken, inject, Input, ViewEncapsulation, Component, Directive, NgModule } from '@angular/core';
import { BidiModule } from '@angular/cdk/bidi';
const _c0 = ["*"];
const _c1 = [[["mat-card-title"], ["mat-card-subtitle"], ["", "mat-card-title", ""], ["", "mat-card-subtitle", ""], ["", "matCardTitle", ""], ["", "matCardSubtitle", ""]], [["", "mat-card-image", ""], ["", "matCardImage", ""], ["", "mat-card-sm-image", ""], ["", "matCardImageSmall", ""], ["", "mat-card-md-image", ""], ["", "matCardImageMedium", ""], ["", "mat-card-lg-image", ""], ["", "matCardImageLarge", ""], ["", "mat-card-xl-image", ""], ["", "matCardImageXLarge", ""]], "*"];
const _c2 = ["mat-card-title, mat-card-subtitle,\n      [mat-card-title], [mat-card-subtitle],\n      [matCardTitle], [matCardSubtitle]", "[mat-card-image], [matCardImage],\n                    [mat-card-sm-image], [matCardImageSmall],\n                    [mat-card-md-image], [matCardImageMedium],\n                    [mat-card-lg-image], [matCardImageLarge],\n                    [mat-card-xl-image], [matCardImageXLarge]", "*"];
const _c3 = [[["", "mat-card-avatar", ""], ["", "matCardAvatar", ""]], [["mat-card-title"], ["mat-card-subtitle"], ["", "mat-card-title", ""], ["", "mat-card-subtitle", ""], ["", "matCardTitle", ""], ["", "matCardSubtitle", ""]], "*"];
const _c4 = ["[mat-card-avatar], [matCardAvatar]", "mat-card-title, mat-card-subtitle,\n      [mat-card-title], [mat-card-subtitle],\n      [matCardTitle], [matCardSubtitle]", "*"];
const MAT_CARD_CONFIG = /*#__PURE__*/new InjectionToken('MAT_CARD_CONFIG');
let MatCard = /*#__PURE__*/(() => {
  class MatCard {
    appearance;
    constructor() {
      const config = inject(MAT_CARD_CONFIG, {
        optional: true
      });
      this.appearance = config?.appearance || 'raised';
    }
    static ɵfac = function MatCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCard)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatCard,
      selectors: [["mat-card"]],
      hostAttrs: [1, "mat-mdc-card", "mdc-card"],
      hostVars: 8,
      hostBindings: function MatCard_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("mat-mdc-card-outlined", ctx.appearance === "outlined")("mdc-card--outlined", ctx.appearance === "outlined")("mat-mdc-card-filled", ctx.appearance === "filled")("mdc-card--filled", ctx.appearance === "filled");
        }
      },
      inputs: {
        appearance: "appearance"
      },
      exportAs: ["matCard"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function MatCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: [".mat-mdc-card {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  position: relative;\n  border-style: solid;\n  border-width: 0;\n  background-color: var(--mat-card-elevated-container-color, var(--mat-sys-surface-container-low));\n  border-color: var(--mat-card-elevated-container-color, var(--mat-sys-surface-container-low));\n  border-radius: var(--mat-card-elevated-container-shape, var(--mat-sys-corner-medium));\n  box-shadow: var(--mat-card-elevated-container-elevation, var(--mat-sys-level1));\n}\n.mat-mdc-card::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: solid 1px transparent;\n  content: \"\";\n  display: block;\n  pointer-events: none;\n  box-sizing: border-box;\n  border-radius: var(--mat-card-elevated-container-shape, var(--mat-sys-corner-medium));\n}\n\n.mat-mdc-card-outlined {\n  background-color: var(--mat-card-outlined-container-color, var(--mat-sys-surface));\n  border-radius: var(--mat-card-outlined-container-shape, var(--mat-sys-corner-medium));\n  border-width: var(--mat-card-outlined-outline-width, 1px);\n  border-color: var(--mat-card-outlined-outline-color, var(--mat-sys-outline-variant));\n  box-shadow: var(--mat-card-outlined-container-elevation, var(--mat-sys-level0));\n}\n.mat-mdc-card-outlined::after {\n  border: none;\n}\n\n.mat-mdc-card-filled {\n  background-color: var(--mat-card-filled-container-color, var(--mat-sys-surface-container-highest));\n  border-radius: var(--mat-card-filled-container-shape, var(--mat-sys-corner-medium));\n  box-shadow: var(--mat-card-filled-container-elevation, var(--mat-sys-level0));\n}\n\n.mdc-card__media {\n  position: relative;\n  box-sizing: border-box;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.mdc-card__media::before {\n  display: block;\n  content: \"\";\n}\n.mdc-card__media:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.mdc-card__media:last-child {\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n}\n\n.mat-mdc-card-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  box-sizing: border-box;\n  min-height: 52px;\n  padding: 8px;\n}\n\n.mat-mdc-card-title {\n  font-family: var(--mat-card-title-text-font, var(--mat-sys-title-large-font));\n  line-height: var(--mat-card-title-text-line-height, var(--mat-sys-title-large-line-height));\n  font-size: var(--mat-card-title-text-size, var(--mat-sys-title-large-size));\n  letter-spacing: var(--mat-card-title-text-tracking, var(--mat-sys-title-large-tracking));\n  font-weight: var(--mat-card-title-text-weight, var(--mat-sys-title-large-weight));\n}\n\n.mat-mdc-card-subtitle {\n  color: var(--mat-card-subtitle-text-color, var(--mat-sys-on-surface));\n  font-family: var(--mat-card-subtitle-text-font, var(--mat-sys-title-medium-font));\n  line-height: var(--mat-card-subtitle-text-line-height, var(--mat-sys-title-medium-line-height));\n  font-size: var(--mat-card-subtitle-text-size, var(--mat-sys-title-medium-size));\n  letter-spacing: var(--mat-card-subtitle-text-tracking, var(--mat-sys-title-medium-tracking));\n  font-weight: var(--mat-card-subtitle-text-weight, var(--mat-sys-title-medium-weight));\n}\n\n.mat-mdc-card-title,\n.mat-mdc-card-subtitle {\n  display: block;\n  margin: 0;\n}\n.mat-mdc-card-avatar ~ .mat-mdc-card-header-text .mat-mdc-card-title,\n.mat-mdc-card-avatar ~ .mat-mdc-card-header-text .mat-mdc-card-subtitle {\n  padding: 16px 16px 0;\n}\n\n.mat-mdc-card-header {\n  display: flex;\n  padding: 16px 16px 0;\n}\n\n.mat-mdc-card-content {\n  display: block;\n  padding: 0 16px;\n}\n.mat-mdc-card-content:first-child {\n  padding-top: 16px;\n}\n.mat-mdc-card-content:last-child {\n  padding-bottom: 16px;\n}\n\n.mat-mdc-card-title-group {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.mat-mdc-card-avatar {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-bottom: 16px;\n  object-fit: cover;\n}\n.mat-mdc-card-avatar ~ .mat-mdc-card-header-text .mat-mdc-card-subtitle,\n.mat-mdc-card-avatar ~ .mat-mdc-card-header-text .mat-mdc-card-title {\n  line-height: normal;\n}\n\n.mat-mdc-card-sm-image {\n  width: 80px;\n  height: 80px;\n}\n\n.mat-mdc-card-md-image {\n  width: 112px;\n  height: 112px;\n}\n\n.mat-mdc-card-lg-image {\n  width: 152px;\n  height: 152px;\n}\n\n.mat-mdc-card-xl-image {\n  width: 240px;\n  height: 240px;\n}\n\n.mat-mdc-card-subtitle ~ .mat-mdc-card-title,\n.mat-mdc-card-title ~ .mat-mdc-card-subtitle,\n.mat-mdc-card-header .mat-mdc-card-header-text .mat-mdc-card-title,\n.mat-mdc-card-header .mat-mdc-card-header-text .mat-mdc-card-subtitle,\n.mat-mdc-card-title-group .mat-mdc-card-title,\n.mat-mdc-card-title-group .mat-mdc-card-subtitle {\n  padding-top: 0;\n}\n\n.mat-mdc-card-content > :last-child:not(.mat-mdc-card-footer) {\n  margin-bottom: 0;\n}\n\n.mat-mdc-card-actions-align-end {\n  justify-content: flex-end;\n}\n"],
      encapsulation: 2
    });
  }
  return MatCard;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardTitle = /*#__PURE__*/(() => {
  class MatCardTitle {
    static ɵfac = function MatCardTitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardTitle)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardTitle,
      selectors: [["mat-card-title"], ["", "mat-card-title", ""], ["", "matCardTitle", ""]],
      hostAttrs: [1, "mat-mdc-card-title"]
    });
  }
  return MatCardTitle;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardTitleGroup = /*#__PURE__*/(() => {
  class MatCardTitleGroup {
    static ɵfac = function MatCardTitleGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardTitleGroup)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatCardTitleGroup,
      selectors: [["mat-card-title-group"]],
      hostAttrs: [1, "mat-mdc-card-title-group"],
      ngContentSelectors: _c2,
      decls: 4,
      vars: 0,
      template: function MatCardTitleGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c1);
          i0.ɵɵdomElementStart(0, "div");
          i0.ɵɵprojection(1);
          i0.ɵɵdomElementEnd();
          i0.ɵɵprojection(2, 1);
          i0.ɵɵprojection(3, 2);
        }
      },
      encapsulation: 2
    });
  }
  return MatCardTitleGroup;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardContent = /*#__PURE__*/(() => {
  class MatCardContent {
    static ɵfac = function MatCardContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardContent)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardContent,
      selectors: [["mat-card-content"]],
      hostAttrs: [1, "mat-mdc-card-content"]
    });
  }
  return MatCardContent;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardSubtitle = /*#__PURE__*/(() => {
  class MatCardSubtitle {
    static ɵfac = function MatCardSubtitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardSubtitle)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardSubtitle,
      selectors: [["mat-card-subtitle"], ["", "mat-card-subtitle", ""], ["", "matCardSubtitle", ""]],
      hostAttrs: [1, "mat-mdc-card-subtitle"]
    });
  }
  return MatCardSubtitle;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardActions = /*#__PURE__*/(() => {
  class MatCardActions {
    align = 'start';
    static ɵfac = function MatCardActions_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardActions)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardActions,
      selectors: [["mat-card-actions"]],
      hostAttrs: [1, "mat-mdc-card-actions", "mdc-card__actions"],
      hostVars: 2,
      hostBindings: function MatCardActions_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("mat-mdc-card-actions-align-end", ctx.align === "end");
        }
      },
      inputs: {
        align: "align"
      },
      exportAs: ["matCardActions"]
    });
  }
  return MatCardActions;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardHeader = /*#__PURE__*/(() => {
  class MatCardHeader {
    static ɵfac = function MatCardHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardHeader)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatCardHeader,
      selectors: [["mat-card-header"]],
      hostAttrs: [1, "mat-mdc-card-header"],
      ngContentSelectors: _c4,
      decls: 4,
      vars: 0,
      consts: [[1, "mat-mdc-card-header-text"]],
      template: function MatCardHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵprojection(0);
          i0.ɵɵdomElementStart(1, "div", 0);
          i0.ɵɵprojection(2, 1);
          i0.ɵɵdomElementEnd();
          i0.ɵɵprojection(3, 2);
        }
      },
      encapsulation: 2
    });
  }
  return MatCardHeader;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardFooter = /*#__PURE__*/(() => {
  class MatCardFooter {
    static ɵfac = function MatCardFooter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardFooter)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardFooter,
      selectors: [["mat-card-footer"]],
      hostAttrs: [1, "mat-mdc-card-footer"]
    });
  }
  return MatCardFooter;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardImage = /*#__PURE__*/(() => {
  class MatCardImage {
    static ɵfac = function MatCardImage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardImage)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardImage,
      selectors: [["", "mat-card-image", ""], ["", "matCardImage", ""]],
      hostAttrs: [1, "mat-mdc-card-image", "mdc-card__media"]
    });
  }
  return MatCardImage;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardSmImage = /*#__PURE__*/(() => {
  class MatCardSmImage {
    static ɵfac = function MatCardSmImage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardSmImage)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardSmImage,
      selectors: [["", "mat-card-sm-image", ""], ["", "matCardImageSmall", ""]],
      hostAttrs: [1, "mat-mdc-card-sm-image", "mdc-card__media"]
    });
  }
  return MatCardSmImage;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardMdImage = /*#__PURE__*/(() => {
  class MatCardMdImage {
    static ɵfac = function MatCardMdImage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardMdImage)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardMdImage,
      selectors: [["", "mat-card-md-image", ""], ["", "matCardImageMedium", ""]],
      hostAttrs: [1, "mat-mdc-card-md-image", "mdc-card__media"]
    });
  }
  return MatCardMdImage;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardLgImage = /*#__PURE__*/(() => {
  class MatCardLgImage {
    static ɵfac = function MatCardLgImage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardLgImage)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardLgImage,
      selectors: [["", "mat-card-lg-image", ""], ["", "matCardImageLarge", ""]],
      hostAttrs: [1, "mat-mdc-card-lg-image", "mdc-card__media"]
    });
  }
  return MatCardLgImage;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardXlImage = /*#__PURE__*/(() => {
  class MatCardXlImage {
    static ɵfac = function MatCardXlImage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardXlImage)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardXlImage,
      selectors: [["", "mat-card-xl-image", ""], ["", "matCardImageXLarge", ""]],
      hostAttrs: [1, "mat-mdc-card-xl-image", "mdc-card__media"]
    });
  }
  return MatCardXlImage;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatCardAvatar = /*#__PURE__*/(() => {
  class MatCardAvatar {
    static ɵfac = function MatCardAvatar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardAvatar)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatCardAvatar,
      selectors: [["", "mat-card-avatar", ""], ["", "matCardAvatar", ""]],
      hostAttrs: [1, "mat-mdc-card-avatar"]
    });
  }
  return MatCardAvatar;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CARD_DIRECTIVES = [MatCard, MatCardActions, MatCardAvatar, MatCardContent, MatCardFooter, MatCardHeader, MatCardImage, MatCardLgImage, MatCardMdImage, MatCardSmImage, MatCardSubtitle, MatCardTitle, MatCardTitleGroup, MatCardXlImage];
let MatCardModule = /*#__PURE__*/(() => {
  class MatCardModule {
    static ɵfac = function MatCardModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCardModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatCardModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [BidiModule]
    });
  }
  return MatCardModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MAT_CARD_CONFIG, MatCard, MatCardActions, MatCardAvatar, MatCardContent, MatCardFooter, MatCardHeader, MatCardImage, MatCardLgImage, MatCardMdImage, MatCardModule, MatCardSmImage, MatCardSubtitle, MatCardTitle, MatCardTitleGroup, MatCardXlImage };
